import { useEffect, useRef } from 'react';

/**
 * rAF-Schleife fuer HUD-Elemente. Der Callback bekommt dt in Sekunden und
 * schreibt direkt in DOM-Refs - React rendert dabei nicht neu.
 */
export function useRafLoop(callback: (dt: number) => void, active = true): void {
  const cbRef = useRef(callback);
  cbRef.current = callback;

  useEffect(() => {
    if (!active) return;
    let raf = 0;
    let last = performance.now();
    const tick = (now: number): void => {
      raf = requestAnimationFrame(tick);
      const dt = Math.min((now - last) / 1000, 0.1);
      last = now;
      cbRef.current(dt);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [active]);
}
